document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.blog-carousel-section__swiper').forEach(function (swiper) {
    if (swiper.classList.contains('swiper-initialized')) return;

    new Swiper(swiper, {
      loop: false,
      spaceBetween: 6,
      slidesPerView: 1.225,
      pagination: {
        el: swiper.querySelector('.swiper-pagination.blog-carousel-section__swiper-pagination'),
        type: 'progressbar',
      },
      grabCursor: true,
      freeMode: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
      },
      watchOverflow: true,
      breakpoints: {
        500: {
          loop: false,
          slidesPerView: 1.45,
          centeredSlides: false,
          spaceBetween: 6,
        },
        600: {
          loop: false,
          slidesPerView: 1.8,
          centeredSlides: false,
          spaceBetween: 8,
        },
        800: {
          loop: false,
          slidesPerView: 2.2,
          centeredSlides: false,
          spaceBetween: 8,
        },
        900: {
          loop: false,
          slidesPerView: 2.6233,
          centeredSlides: false,
          spaceBetween: 8,
        },
      },
    });
  });
});